import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, Dropdown, Button, Badge } from 'react-bootstrap';
import { API_BASE_URL } from '../../config/config';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaBars, FaTimes, FaHome, FaNewspaper, FaUsers, FaCog, FaSignOutAlt, FaBell, FaEdit, FaEye, FaChartLine, FaEnvelope, FaShareAlt, FaList, FaMailBulk, FaVoicemail, FaMailchimp } from 'react-icons/fa';
import './Navigation.css';

function Navigation({ user, onLogout, currentPage = 'home' }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [quota, setQuota] = useState({ remaining: null, limit: null });
  const navigate = useNavigate();

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      localStorage.removeItem('user');
      window.location.href = '/';
    }
  };

  const toggleNavbar = () => {
    setIsExpanded(!isExpanded);
  };

  const closeNavbar = () => {
    setIsExpanded(false);
  };

  // Lightweight polling for Brevo quota (every 60s)
  useEffect(() => {
    let cancelled = false;
    let timer;
    async function loadQuota() {
      try {
        const resp = await fetch(`${API_BASE_URL}/emails/quota`);
        const data = resp.ok ? await resp.json() : { remaining: null, limit: null };
        if (!cancelled) setQuota({ remaining: data?.remaining ?? null, limit: data?.limit ?? null });
      } catch (e) {
        if (!cancelled) setQuota({ remaining: null, limit: null });
      }
    }
    loadQuota();
    timer = setInterval(loadQuota, 60000);
    return () => { cancelled = true; if (timer) clearInterval(timer); };
  }, []);

  const menuItems = [
    { id: 'home', label: 'Homepage', icon: <FaHome />, path: '/homepage' },
  ];

  const journalSubItems = [
    { id: 'create', label: 'Send Emails', icon: <FaEdit />, path: '/journal/send-emails' },
    { id: 'list-academicians', label: 'List Academicians', icon: <FaList />, path: '/journal/list-academicians' },
    
  ];

  return (
    <Navbar 
      bg="dark" 
      variant="dark" 
      expand="lg" 
      className="custom-navbar"
      expanded={isExpanded}
    >
      <Container fluid>
        {/* Logo/Brand */}
        <Navbar.Brand as={Link} to="/homepage" className="brand-logo">
          <img 
            src="/images/logo.png" 
            alt="JOCACS Logo" 
            height="70" 
            className="d-inline-block align-top me-2"
          />
        </Navbar.Brand>

        {/* Mobile Toggle Button */}
        <Navbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={toggleNavbar}
          className="navbar-toggler-custom"
        >
          {isExpanded ? <FaTimes /> : <FaBars />}
        </Navbar.Toggle>

        {/* Navigation Items */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {menuItems.map((item) => (
              <Nav.Link
                key={item.id}
                as={Link}
                to={item.path}
                className={`nav-link-custom ${currentPage === item.id ? 'active' : ''}`}
                onClick={closeNavbar}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </Nav.Link>
            ))}
            
            {/* Journal Promotion Dropdown */}
            <Dropdown className="nav-item">
              <Dropdown.Toggle as={Nav.Link} className="nav-link-custom dropdown-toggle-custom">
                <span className="nav-icon"><FaNewspaper /></span>
                <span className="nav-label">Journal Promotion</span>
              </Dropdown.Toggle>
              
              <Dropdown.Menu className="journal-dropdown-menu">
                {journalSubItems.map((subItem) => (
                  <Dropdown.Item 
                    key={subItem.id} 
                    as={Link}
                    to={subItem.path}
                    className="dropdown-item-custom"
                    onClick={closeNavbar}
                  >
                    <span className="sub-item-icon">{subItem.icon}</span>
                    <span className="sub-item-label">{subItem.label}</span>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </Nav>

          {/* Right Side - Quota & User Dropdown */}
          <Nav className="ms-auto">
            <div className="d-flex align-items-center me-3">
              <span className="text-light small me-2">Daily Mail Quota</span>
              <Badge bg="primary">{quota.remaining ?? 'N/A'} / {quota.limit ?? 'N/A'}</Badge>
            </div>
            <Dropdown align="end">
              <Dropdown.Toggle variant="dark" className="user-dropdown-toggle">
                <div className="user-info">
                  <div className="user-avatar">
                    <FaUser />
                  </div>
                  <div className="user-details">
                    <span className="username">{user?.username}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown-menu">
                <Dropdown.Header>
                  <strong>{user?.username}</strong>
                  <br />
                  <small className="text-muted">{user?.email}</small>
                </Dropdown.Header>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout} className="logout-item">
                  <FaSignOutAlt className="me-2" /> Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
